import React from 'react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: { main: '#16a34a' },
    secondary: { main: '#1d4ed8' },
    background: { default: '#ffffff', paper: '#ffffff' },
    text: { primary: '#111827', secondary: '#4b5563' },
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
});

export function AppThemeProvider({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
